import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ItemResponse, PortalForecastResponse } from '@proerp/shared';
import { portalRequest } from './apiClient';

export const PORTAL_FORECAST_KEY = ['portal', 'forecast'] as const;

/**
 * Die erwarteten Mengen für diesen Lieferanten (ADR 0085, Stufe 1).
 *
 * `enabled` ist für die Übersicht da: Sie zeigt Kennzahlen aus beiden Sichten,
 * darf aber keine anfragen, die für diesen Zugang gesperrt ist — das gäbe ein
 * 403 und eine Fehlermeldung für etwas, das gar nicht gefragt werden sollte.
 */
export function usePortalForecast(
  options: { enabled?: boolean } = {},
): UseQueryResult<PortalForecastResponse> {
  return useQuery({
    queryKey: PORTAL_FORECAST_KEY,
    queryFn: async () => {
      const response = await portalRequest<ItemResponse<PortalForecastResponse>>('/forecast');
      return response.data;
    },
    enabled: options.enabled ?? true,
    retry: false,
  });
}
